import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { apiFetch } from "../../app/apiClient";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { currentToken, sessionRehydrated, userLoggedIn } from "../login/loginSlice";
import ComposeMailItem from "./components/ComposeMailItem";
import FolderContents from "./components/FolderContents";
import FolderView from "./components/FolderView";
import PreviewPane from "./components/PreviewPane";
import { emailsBeingWritten } from "./emailSlice";
import { setSendAsAddresses } from "./sendAsSlice";
import "./Inbox.scss";

function Inbox() {
    let dispatch = useAppDispatch();
    let userToken = useAppSelector(currentToken);
    let loggedIn = useAppSelector(userLoggedIn);
    let newEmails = useAppSelector(emailsBeingWritten)?.map((email) => {
        return <ComposeMailItem email={email} emailHeader={email.header} key={email.guid} />
    });

    // The addresses this user may send from feed every compose window's From
    // dropdown, so load them once here rather than per window.
    useEffect(() => {
        if (!loggedIn) {
            return;
        }
        const abortController = new AbortController();
        async function loadSendAsAddresses() {
            try {
                const response = await apiFetch("/api/account/sendAs", {
                    method: "GET",
                    token: userToken,
                    signal: abortController.signal
                });
                if (!response.ok) {
                    return;
                }
                const data = await response.json();
                dispatch(setSendAsAddresses(data.addresses || []));
            } catch (error: any) {
                // Compose falls back to the user's own address when this is unavailable
            }
        }
        loadSendAsAddresses();
        return () => abortController.abort();
    }, [loggedIn, userToken, dispatch]);

    let rehydrated = useAppSelector(sessionRehydrated);
    if (!rehydrated) {
        return null;
    }
    if (!loggedIn) {
        return <Navigate to="/login" />
    }
    return(<div id="inboxContent" className={"inboxPage"}>
        <div className={"emailsBeingComposed"}>{newEmails}</div>
        <FolderView />
        <FolderContents />
        <PreviewPane />
    </div>)
}

export default Inbox;